














import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component
export default class NewsDetail extends Vue {
  public name: string = "scroll";
  @Prop({ default: false }) private horizontal!: boolean;
  @Prop({ default: false }) private vertical!: boolean;
  // 终端 false为PC 待扩展
  @Prop({ default: false }) private terminal!: boolean;
  // 速度
  @Prop({ default: 300 }) private speed!: number;
  @Prop() private wrapW!: number;
  @Prop() private eqid!: string;
  @Prop({ default: false }) private verticalBarShow!: boolean;
  @Prop({ default: 0 }) private clTop!: number;

  private verticalShow: boolean = this.vertical;
  private horizontalShow: boolean = this.horizontal;
  private barMinX: number = 0;
  private barMaxX: number = 0;
  private barMinY: number = 0;
  private barMaxY: number = 0;
  private timer: any = null;
  private verticalCur: boolean = false;
  private horizontalCur: boolean = false;

  private mouse: any;
  private refWrap: any;
  private refList: any;
  private listW: any;
  private barH: any;
  private barHMain: any;
  private barV: any;
  private barVMain: any;
  private listH: any;

  // 初始化
  private _initScroll() {
    this._set();
    this._refresh();
  }

  // 设置参数
  private _set() {
    this.mouse = {};  // mouse对象
    this.refWrap = this.$refs.wrapper;
    this.refList = this.$refs.list;
    if (this.horizontal) {
      this.listW = this.wrapW || this.refList.offsetWidth;
      this.barH = this.$refs.barH;
      this.barHMain = this.$refs.barHMain;
    }
    if (this.vertical) {
      this.barV = this.$refs.barV;
      this.barVMain = this.$refs.barVMain;
    }
    this.refList.style.position = 'relative';
  }

  // 计算刷新
  private _refresh() {
    /**
     * 横向
     */
    if (this.horizontal) {
      this.horizontalShow = true;
      if (this.listW <= this.refWrap.offsetWidth) {
        this.horizontalShow = false;
        this._scrollX_To(0, 'set');
        return;
      } else {
        this.barHMain.style.width = this.refWrap.offsetWidth / this.listW * this.barH.offsetWidth + 'px';
        this.$nextTick(() => {
          const offX = this.refWrap.offsetWidth * this.barH.offsetWidth / this.listW;
          this.barHMain.style.width = offX + 'px';
          this.barMinX = this.barH.getBoundingClientRect().left;
          this.barMaxX = Math.floor(this.barH.offsetWidth - offX);
          this.mouse.proportionX = (this.refList.offsetWidth - this.barH.offsetWidth) / this.barMaxX;
        });
      }
    }

    /**
     * 纵向
     */
    if (this.vertical) {
      this.verticalShow = true;
      this.listH = this.refList.offsetHeight;
      // 小于母体高度 隐藏
      if (this.listH <= this.refWrap.offsetHeight) {
        this.verticalBarShow = false;
        this.verticalShow = false;
        return;
      } else {
        this.$nextTick(() => {
          this.barVMain.style.height = this.refWrap.offsetHeight / this.listH * this.barV.offsetHeight + 'px';
          const offY = this.refWrap.offsetHeight * this.barV.offsetHeight / this.listH;
          this.barMinY = this.barV.getBoundingClientRect().top;
          this.barMaxY = Math.floor(this.barV.offsetHeight - offY);
          this.mouse.proportionY = (this.refList.offsetHeight - this.barV.offsetHeight) / this.barMaxY;
        });
      }
    }
  }

  private _down(even: any) {
    this.mouse.startX = even.clientX;
    this.mouse.switch = true;
    this.mouse.x = even.target.offsetLeft;
    this.barHMain.className += ' cur';
  }

  private _downY(even: any) {
    this.mouse.startY = even.clientY;
    this.mouse.switchY = true;
    this.mouse.y = even.target.offsetTop;
  }

  private _enter() {
    this._refresh();
    if (this.verticalShow) {
      this.verticalCur = true;
    }
    if (this.horizontalShow) {
      this.horizontalCur = true;
    }
  }

  private _leave() {
    this.horizontalCur = false;
    this.verticalCur = false;
  }

  private _click(even: any) {
    if (this.mouse.switch) {
      return;
    }
    this.mouse.x = 0;
    this.mouse.startX = this.barMinX;
    this._animated(this.barHMain, 'left');
    this._scrollX_To(even.clientX - this.barHMain.offsetWidth * 0.5, "");
  }

  private _clickY(even: any) {
    if (this.mouse.switchY) {
      return;
    }
    this.mouse.startY = this.barMinY;
    this.mouse.y = 0;
    this._animated(this.barVMain, 'top');
    this._scrollY_To(even.clientY - this.barVMain.offsetHeight * 0.5, "");
  }

  private _scrollX_To(vx: number, type: string) {
    let x = 0;
    this.horizontalCur = true;
    if (type === 'set') {
      x = vx;
    } else {
      x = vx - (this.mouse.startX || 0) + (this.mouse.x || 0);
    }
    this.mouse.nowX = x <= 0 ? 0 : (x >= this.barMaxX ? this.barMaxX : x);
    this.barHMain.style.left = this.mouse.nowX + 'px';
    this.refList.style.left = -1 * this.mouse.nowX * this.mouse.proportionX + 'px';
  }

  private _scrollY_To(dy: number, type: string) {
    let y = 0;
    this.verticalCur = true;
    if (type === 'wheel' || type === 'set') {
      y = dy;
    } else {
      y = dy - (this.mouse.startY || 0) + (this.mouse.y || 0);
    }
    this.mouse.nowY = y <= 0 ? 0 : (y >= this.barMaxY ? this.barMaxY : y);
    this.barVMain.style.top = this.mouse.nowY + 'px';
    this.refList.style.top = -1 * this.mouse.nowY * this.mouse.proportionY + 'px';
  }

  private _animated(el: any, direction: any) {
    clearTimeout(this.timer);
    this.refList.style.transition = direction + ' ' + this.speed + 'ms';
    el.style.transition = direction + ' ' + this.speed + 'ms';
    this.timer = setTimeout(() => {
      el.style.transition = direction + ' ' + '0ms';
      this.refList.style.transition = direction + ' ' + '0ms';
    }, this.speed);
  }

  private _mouseup() {
    if (this.mouse) {
      this.mouse.switch = false;
      this.mouse.switchY = false;
      this.verticalCur = false;
      this.horizontalCur = false;
    }
  }

  private _wheel(event: any) {
    const sp = this.speed / 20;
    const cy = event.deltaY > 0 ? (this.mouse.nowY || 0) + sp : (this.mouse.nowY || 0) - sp;
    if (this.verticalShow) {
      this._scrollY_To(cy, 'wheel');
    }
    event.preventDefault();
  }

  private _mousemove(even: any) {
    if (this.mouse && this.mouse.switch) {
      this._scrollX_To(even.clientX, "");
    }
    if (this.mouse && this.mouse.switchY) {
      this._scrollY_To(even.clientY, "");
    }
    return false;
  }

  private mounted() {
    this._initScroll();
    window.addEventListener('mousemove', this._mousemove);
    window.addEventListener('mouseup', this._mouseup);
    if (this.vertical) {
      (this.$refs.wrapper as Element).addEventListener('wheel', this._wheel);
    }
    // this.vertical ? (this.$refs.wrapper as Element).addEventListener('wheel', this._wheel) : '';
    window.onresize = () => {
      this._refresh();
      if (this.horizontal) {
        this._scrollX_To(this.mouse.nowX, 'set');
      }
      if (this.vertical) {
        this._scrollY_To(this.mouse.nowY, 'set');
      }
    };
  }

  private destroyed() {
    window.removeEventListener('mouseup', this._mouseup);
    window.removeEventListener('mousemove', this._mousemove);
    window.onresize = null;
  }
}
